
//Obtiene un candy por su strMCode.
export function GetCandy(JsonCandys, strMCode, strBarcode) {
    return JsonCandys.reduce((foundCandy, category) => {
        if (!foundCandy) {
            foundCandy = category.Candys.find(t =>
                t.strMCode === strMCode &&
                (
                    (strBarcode === undefined && t.strBarcode === undefined) ||
                    (strBarcode === null && (t.strBarcode === null || t.strBarcode === undefined)) ||
                    (strBarcode !== undefined && t.strBarcode === strBarcode)
                )
            );
        }
        return foundCandy;
    }, null);
}


//Obtiene un option de un candy por su intRecogId.
export function GetOption(TicketCandy, intRecogId, intPromoId) {
    var option = TicketCandy.BuyOptions.find(o => o.intRecogId == intRecogId && o.intPromoId == intPromoId);
    return option;
}


//Crea y actualiza el carrito de candys.
export function UpdateOrder(CartCandys, strMCode, strBarcode, intRecogId, intQty, boms, intPromoId) {
    boms == 'undefined' || boms == null && (boms = []);

    var orderCandy = { strMCode: strMCode, strBarcode: strBarcode, intRecogId: intRecogId, intQty: intQty, boms: boms, intPromoId: intPromoId };
    var estaba = false;
    var removeItemIndex = -1;
    if (CartCandys != null) {
        if (orderCandy.boms.length == 0 || orderCandy.intQty < 0) {
            CartCandys.forEach(orderItem => {
                if ((orderItem.strMCode == orderCandy.strMCode) && (orderItem.strBarcode == orderCandy.strBarcode) && (orderItem.intRecogId == orderCandy.intRecogId) && (orderItem.intPromoId == orderCandy.intPromoId) && !estaba && ObjectEquals(orderItem.boms, orderCandy.boms)) {
                    estaba = true;
                    orderItem.intQty = orderItem.intQty + orderCandy.intQty;
                    orderItem.intQty == 0 && (removeItemIndex = CartCandys.indexOf(orderItem));
                }
            });
            removeItemIndex !== -1 && CartCandys.splice(removeItemIndex, 1);
        }
    } else {
        CartCandys = [];
    }

    if (estaba == false) {
        if (orderCandy.intQty > 0) {
            CartCandys.push(orderCandy);
        }
    }
    return CartCandys;
}


//Retorna la cantidad de Candys totales o por un strMCode, strBarcode, intRecogId y intPromoId.
export function GetQty(JsonCandys, CartCandys, strMCode, strBarcode, intRecogId, intPromoId) {
    if (CartCandys == null)
        return 0;

    var intQty = 0;

    CartCandys.forEach(orderItem => {
        if (!StringIsNullOrEmpty(strMCode)) {
            if (orderItem.strMCode == strMCode && orderItem.strBarcode == strBarcode && orderItem.intRecogId == intRecogId && orderItem.intPromoId == intPromoId) {
                intQty = intQty + orderItem.intQty;
            }
        }
        else {
            intQty = intQty + orderItem.intQty;
        }
    });

    return intQty;
}


//Retorno un string con el Subtotal de la Orden
export function GetStringSubtotalValue(JsonCandys, CartCandys, total_tickets_value) {
    if (CartCandys == null)
        return '$0';

    var totalPrice = 0;

    CartCandys.forEach(orderItem => {
        var ticket = GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = GetOption(ticket, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
            b.Options.forEach(option => {
                totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
            })
        })
        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
    });
    var price = ((totalPrice + total_tickets_value) / 100).toLocaleString('es-AR');
    var result = "$" + price;
    return result;
}


//Devuelte el strTitle del primer ticket que se encuentre para onlyBuy.
export function FirsItemOnlyBuy(JsonCandys, CartCandys) {
    if (CartCandys == null || CartCandys.length == 0) {
        return '';
    }
    var result = "";
    CartCandys.forEach(item => {
        var candy = GetCandy(JsonCandys, item.strMCode, item.strBarcode);

        if (candy.bitOnlyBook) {
            result = candy.strTitle;
        }
    });
    return result;
}


function StringIsNullOrEmpty(value) {
    return !(typeof value === "string" && value.length > 0);
}


function ObjectEquals(x, y) {
    if (x === y) return true;

    if (!(x instanceof Object) || !(y instanceof Object)) return false;

    if (x.constructor !== y.constructor) return false;

    for (var p in x) {
        if (!x.hasOwnProperty(p)) continue;

        if (!y.hasOwnProperty(p)) return false;

        if (x[p] === y[p]) continue;

        if (typeof (x[p]) !== "object") return false;

        if (!ObjectEquals(x[p], y[p])) return false;
    }

    for (p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
    }
    return true;
}

export function GetTotalValue(JsonCandys, CartCandys) {
    if (CartCandys == null)
        return 0;

    var totalPrice = 0;
    CartCandys.forEach(orderItem => {
        var ticket = GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = GetOption(ticket, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
            b.Options.forEach(option => {
                totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
            })
        })
        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
    });
    var price = totalPrice / 100;

    return price;
}


// WEBPACK FOOTER //
// ./src/functionsCandys.js